import _ from 'lodash';

import { TSeasonDef } from '../../../shared/gameConfig/mythicPlus';

export const ZONE_COLORS_BY_SLUG: Record<string, string> = {
  'arakara-city-of-echoes': '#b3667f',
  'city-of-threads': '#931a55',
  'grim-batol': '#916b91',
  'mists-of-tirna-scithe': '#0c28b0',
  'siege-of-boralus': '#a3593b',
  'the-dawnbreaker': '#c4bd68',
  'the-necrotic-wake': '#6d8d4d',
  'the-stonevault': '#a33b10',
  'algethar-academy': '#4A90E2',
  ataldazar: '#FFD700',
  'black-rook-hold': '#2F4F4F',
  'brackenhide-hollow': '#556B2F',
  'cathedral-of-eternal-night': '#483D8B',
  'cinderbrew-meadery': '#D2691E',
  'court-of-stars': '#1E90FF',
  'doti-galakronds-fall': '#708090',
  'doti-murozonds-rise': '#4682B4',
  'darkflame-cleft': '#8B0000',
  'darkheart-thicket': '#006400',
  'de-other-side': '#9400D3',
  'eye-of-azshara': '#00BFFF',
  freehold: '#DAA520',
  'grimrail-depot': '#A9A9A9',
  'halls-of-atonement': '#800000',
  'halls-of-infusion': '#4682B4',
  'halls-of-valor': '#FFD700',
  'iron-docks': '#708090',
  'kings-rest': '#DAA520',
  'maw-of-souls': '#2F4F4F',
  'operation-mechagon-junkyard': '#808080',
  'operation-mechagon-workshop': '#696969',
  'neltharions-lair': '#8B0000',
  neltharus: '#B22222',
  plaguefall: '#556B2F',
  'priory-of-the-sacred-flame': '#FF4500',
  'return-to-karazhan-lower': '#4B0082',
  'return-to-karazhan-upper': '#6A5ACD',
  'ruby-life-pools': '#DC143C',
  'sanguine-depths': '#8B0000',
  'seat-of-the-triumvirate': '#483D8B',
  'shadowmoon-burial-grounds': '#2E8B57',
  'shrine-of-the-storm': '#1E90FF',
  'spires-of-ascension': '#87CEEB',
  'tazavesh-soleahs-gambit': '#FFD700',
  'tazavesh-streets-of-wonder': '#FF69B4',
  'temple-of-sethraliss': '#DAA520',
  'temple-of-the-jade-serpent': '#00FF7F',
  'the-arcway': '#4B0082',
  'the-azure-vault': '#1E90FF',
  everbloom: '#228B22',
  'the-motherlode': '#B8860B',
  'the-nokhud-offensive': '#8B4513'
};
export function filterDungeonsBySeason(season: TSeasonDef, dungeonPath?: string): (dg: any) => boolean {
  return (item) => {
    const dungeon = dungeonPath ? _.get(item, dungeonPath) : item;
    return isDungeonAccessibleInSeason(season, dungeon);
  };
}

export const isDungeonAccessibleInSeason = (
  season: TSeasonDef,
  dungeon: {
    expansion_id: number;
    patch: string;
    id: number;
  }
) => {
  if (season.allowedDungeons && season.allowedDungeons.includes(dungeon.id)) {
    return true;
  }

  return (
    dungeon.expansion_id === season.expansionId &&
    (!season.allowedDungeonPatches || season.allowedDungeonPatches.includes(dungeon.patch))
  );
};
